import { handleFetchResponse } from './http.utils';
import { IHttpError, IHttpService } from './http.interface';
import { injectable } from 'inversify';

@injectable()
export class HttpService implements IHttpService {
    get<T>(url: string): Promise<[T, IHttpError?]> {
        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        };

        return fetch(url, options)
            .then(async (resp) => handleFetchResponse<T>(resp))
            .catch((message) => {
                return [ undefined, {
                    code: -1, // Not an HTTP error
                    message,
                } ] as [T, IHttpError];
            });
    }

    post<T>(url: string, body?: unknown, addedOptions: Record<string, unknown> = {}): Promise<[T, IHttpError?]> {
        const options = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
            ...addedOptions,
        };

        return fetch(url, options)
            .then(async (resp) => handleFetchResponse<T>(resp))
            .catch((message) => {
                return [ undefined, {
                    code: -1, // Not an HTTP error
                    message,
                } ] as [T, IHttpError];
            });
    }
}
